import React from "react";
import { StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import variables from "../../styles/variables";

export type RTVGradientProps = {
  children?: React.ReactNode;
  height?: number;
  boxMode?: boolean;
};

const { colors } = variables;

// JSDOC
/**
 * RTVGradient is a component that provides a linear gradient background.
 * It can be used to create visually appealing sections in your app.
 *
 * @param {number} height - The maximum height of the gradient.
 * @param {React.ReactNode} children - The content to be displayed inside the gradient.
 * @param {boolean} boxMode - If true, applies a border radius to gradient and removes child alignment.
 * @returns {JSX.Element} The RTVGradient component.
 */
const RTVGradient = ({
  height,
  children,
  boxMode = false,
}: RTVGradientProps) => {
  return (
    <LinearGradient
      start={{ x: 0, y: 1 }}
      end={{ x: 1, y: 1 }}
      style={[
        styles.container,
        { maxHeight: height },
        boxMode ? { borderRadius: 5 } : { alignItems: "center" },
      ]}
      colors={[
        colors.palette.rtv.primary,
        colors.palette.rtv.tertiary,
        colors.palette.rtv.secondary,
        colors.palette.rtv.primary,
      ]}
    >
      {children}
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    justifyContent: "center",
    minHeight: 5, //min height required if children not provided
    zIndex: -10,
  },
});

export default RTVGradient;
